import VAvatar from './VAvatar';
export { VAvatar };
export default VAvatar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/lib/components/VAvatar/index.js
// module id = null
// module chunks = 